import React, { useState } from 'react';
import { Tab as ReactTabs, Tabs, TabList, TabPanel } from 'react-tabs';
import { PropTypes } from 'prop-types';
import 'react-tabs/style/react-tabs.css';
import styles from './tab.module.scss';



export const Tab = ({ tabList, onSelect, defaultIndex, selectedIndex, workListView, tissueView,woundReportView,histCause, tabRemove }) => {
    return (
        <Tabs focusTabOnClick={false} onSelect={onSelect} className={tissueView && styles.tissueview_outer}
        {...(selectedIndex !== undefined ? { selectedIndex } : { defaultIndex: defaultIndex ?? 0 })}>
            {!tabRemove && <TabList className={`${styles.react_tabs} ${tissueView && styles.tissueview_fix}`}>
                {/* Map through tabs  */}
                {tabList.map(tab => (
                    <ReactTabs className={(woundReportView)? styles.wound_report_view:(histCause)?styles.hist_cause_list:styles.react_tabs_list} selectedClassName={styles.selected} key={tab.key}>{tab.name}</ReactTabs>
                ))}
            </TabList>}
            <div className={!tabRemove && styles.hr_Line}/>
            {/* Map throgh tab panel */}
            {tabList.map((tabC) => (
                <TabPanel
                    className={`${styles.react_tab_pane} ${(tabC.className) ? tabC.className : ''} ${workListView ? styles.fixed_width : ''} `}
                    selectedClassName={styles.selected}
                    key={tabC.key}>{tabC.content}
                </TabPanel>
            ))}
        </Tabs>
    );
};

Tab.propTypes = {
    tabList: PropTypes.array,
    tanPanelClass : PropTypes.object,
    onSelect: PropTypes.func,
    selectedIndex: PropTypes.number,
    tabShadowNone:PropTypes.any,
    workListView:PropTypes.bool
};
